import { StyledAnonymousQuestionsList } from "./index.styled";
import SectionTitle from "../../dashboard/SectionTitle";
import anonymousTitleIcon from "../../../assets/icons/anonymous-title-icon.png";
import noQuestionIcon from "../../../assets/icons/no-question.jpg";
import type { AnonymousQuestion } from "../../../types/dashboard";
import AnonymousQuestionItem from "../AnonymousQuestionItem";

interface AnonymousQuestionsListProps {
  questions: AnonymousQuestion[];
  title?: string;
  loading?: boolean;
}

const AnonymousQuestionsList = ({
  questions,
  title = "התיבות שלך",
  loading = false,
}: AnonymousQuestionsListProps) => {
  return (
    <StyledAnonymousQuestionsList>
      <div className={`questions-header ${questions.length > 0 ? "has-questions" : ""}`}>
        <SectionTitle title={title} />
        <img
          className="anonymous-title-icon"
          src={anonymousTitleIcon}
          alt="anonymous title"
        />
      </div>
      {questions.length > 0 && (
        <p className="questions-subtitle">
          לחצו על התיבה לצפיה בדף התגובות
        </p>
      )}
      {loading ? (
        <div className="questions-empty">
          <p className="questions-empty-text">טוען שאלות...</p>
        </div>
      ) : questions.length === 0 ? (
        <div className="questions-empty">
          <img
            className="questions-empty-icon"
            src={noQuestionIcon}
            alt="no questions"
          />
          <p className="questions-empty-text">
            עוד לא פרסמת את השאלה הראשונה שלך
            <br />
            כשזה יקרה היא תופיע כאן :)
          </p>
        </div>
      ) : (
        <ul className="questions-list">
          {questions.map((question) => (
            <AnonymousQuestionItem
              key={question.id || question.short_code}
              question={question}
            />
          ))}
        </ul>
      )}
    </StyledAnonymousQuestionsList>
  );
};

export default AnonymousQuestionsList;
